module.exports = __webpack_public_path__ + "media/images/mobile/abouts/m_jg2-1602332b1894b05e210ee64bb6823be1.png";